import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/0c3b91f5a78bf116a8f1933873ec41d9.png" 
              alt="ローカルマーケティングラボ" 
              className="h-10 md:h-[60px] w-auto"
            />
            <span className="text-black font-semibold text-lg">ローカルマーケティングラボ</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-800 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Top
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-800 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('voices')}
              className="text-gray-800 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Voices
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-800 hover:text-blue-600 font-medium transition-colors cursor-pointer"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 text-white px-6 py-2 rounded-[10px] font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer flex items-center"
            >
              <i className="ri-mail-line text-lg mr-2"></i>
              お問い合わせ
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-800 hover:bg-gray-100 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-gray-800 hover:text-blue-600 font-medium py-2 cursor-pointer text-left"
              >
                Top
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-800 hover:text-blue-600 font-medium py-2 cursor-pointer text-left"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('voices')}
                className="text-gray-800 hover:text-blue-600 font-medium py-2 cursor-pointer text-left"
              >
                Voices
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-800 hover:text-blue-600 font-medium py-2 cursor-pointer text-left"
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-blue-600 text-white px-6 py-2 rounded-[10px] font-medium hover:bg-blue-700 transition-colors text-left whitespace-nowrap cursor-pointer flex items-center"
              >
                <i className="ri-mail-line text-lg mr-2"></i>
                お問い合わせ
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
